import { DetailsRowGlobalClassNames, } from 'office-ui-fabric-react/lib/DetailsList';
import { FontWeights, getGlobalClassNames } from '@uifabric/styling';
export var CheckStyles = function (props) {
    var theme = props.theme, checked = props.checked;
    var palette = theme.palette;
    return {
        circle: [!checked && { color: palette.neutralSecondary }],
        check: [!checked && { color: palette.neutralSecondary }],
    };
};
export var DetailsRowStyles = function (props) {
    var _a;
    var theme = props.theme, isSelected = props.isSelected;
    var palette = theme.palette;
    var neutralPrimary = palette.neutralPrimary, neutralSecondary = palette.neutralSecondary, neutralLight = palette.neutralLight, neutralQuaternaryAlt = palette.neutralQuaternaryAlt;
    var classNames = getGlobalClassNames(DetailsRowGlobalClassNames, theme);
    return {
        root: [
            {
                color: neutralSecondary,
            },
            isSelected && {
                color: neutralPrimary,
            },
            {
                selectors: (_a = {},
                    _a[":focus ." + classNames.check] = {
                        opacity: 1,
                    },
                    _a),
            },
            isSelected && [
                {
                    background: neutralLight,
                    selectors: {
                        ':hover': {
                            background: neutralQuaternaryAlt,
                        },
                        ':focus': {
                            background: neutralLight,
                        },
                        ':focus:hover': {
                            background: neutralQuaternaryAlt,
                        },
                    },
                },
            ],
        ],
        isRowHeader: [
            {
                color: neutralPrimary,
            },
            isSelected && {
                fontWeight: FontWeights.semibold,
            },
        ],
    };
};
//# sourceMappingURL=DetailsList.styles.js.map